import { Renderer2 } from '@angular/core';

export interface ClipboardContent {
  plain: string;
  html: string;
}

export const writeToClipboard = (content: ClipboardContent): Promise<void> =>
  // Older browsers (Firefox < 127) have no ClipboardItem; plain text is better than nothing there
  typeof ClipboardItem !== 'undefined'
    ? navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([content.plain], { type: 'text/plain' }),
          'text/html': new Blob([content.html], { type: 'text/html' }),
        }),
      ])
    : navigator.clipboard.writeText(content.plain);

export const showCopiedPopup = (renderer: Renderer2, anchor: HTMLElement, text = 'Gekopieerd naar klembord'): void => {
  const rect = anchor.getBoundingClientRect();

  const popup = renderer.createElement('div');
  renderer.addClass(popup, 'copy-feedback-popup');
  renderer.setAttribute(popup, 'role', 'status');
  renderer.appendChild(popup, renderer.createText(text));

  renderer.setStyle(popup, 'background', '#AAAAAA');
  renderer.setStyle(popup, 'padding', '0.2rem');
  renderer.setStyle(popup, 'border-radius', '10px');
  renderer.setStyle(popup, 'position', 'absolute');
  renderer.setStyle(popup, 'top', `${(rect.top + window.scrollY - 40).toString()}px`);
  renderer.setStyle(popup, 'left', `${(rect.left + window.scrollX).toString()}px`);
  renderer.setStyle(popup, 'z-index', '1000');

  renderer.appendChild(document.body, popup);
  setTimeout(() => {
    renderer.removeChild(document.body, popup);
  }, 2000);
};
